"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.populateFeatureTranslations = exports.mapSearchPropertiesEndpointReviewsToCommonAggregationReviews = exports.mapSearchPropertiesEndpointRegionsToCommonRegions = void 0;
const utils_1 = require("./utils");
const isNumber = (value) => !Number.isNaN(value);
const mapSearchPropertiesEndpointRegionToCommonRegion = (endpointRegion) => {
    return {
        count: endpointRegion.count,
        region: endpointRegion.regionName,
        id: endpointRegion.regionCode,
    };
};
const mapSearchPropertiesEndpointRegionsToCommonRegions = (coordinatesRegions) => {
    return {
        rhs1: coordinatesRegions.rhs1.map((region) => mapSearchPropertiesEndpointRegionToCommonRegion(region)),
        rhs2: coordinatesRegions.rhs2.map((region) => mapSearchPropertiesEndpointRegionToCommonRegion(region)),
        rhs3: coordinatesRegions.rhs3.map((region) => mapSearchPropertiesEndpointRegionToCommonRegion(region)),
        rhs4: coordinatesRegions.rhs4.map((region) => mapSearchPropertiesEndpointRegionToCommonRegion(region)),
        rhs5: coordinatesRegions.rhs5.map((region) => mapSearchPropertiesEndpointRegionToCommonRegion(region)),
    };
};
exports.mapSearchPropertiesEndpointRegionsToCommonRegions = mapSearchPropertiesEndpointRegionsToCommonRegions;
const mapSearchPropertiesEndpointReviewsToCommonAggregationReviews = (endpointReviews) => {
    return endpointReviews
        .filter((endpointReview) => isNumber(endpointReview.count) && isNumber(endpointReview.score))
        .map((endpointReview) => {
        return {
            score: endpointReview.score ?? 0,
            count: endpointReview.count ?? 0,
        };
    });
};
exports.mapSearchPropertiesEndpointReviewsToCommonAggregationReviews = mapSearchPropertiesEndpointReviewsToCommonAggregationReviews;
const populateFeatureTranslations = (features, language) => {
    const featuresHasOnlyIds = features.length > 0 && !features[0]?.featureName;
    return featuresHasOnlyIds
        ? (0, utils_1.mapNovasolFeaturesToAggregationFeatures)(features, language)
        : features;
};
exports.populateFeatureTranslations = populateFeatureTranslations;
//# sourceMappingURL=mapPropertiesToCommon.js.map